import { Box, Typography, Button, CircularProgress } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import AddIcon from '@mui/icons-material/Add';
import EligibilityTable from './components/EligibilityTable';
import { getCurrentUser, User } from '../services/userService';

const EligibilityList = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const activeStatus = searchParams.get('activeStatus');
  const groupId = searchParams.get('groupId');
  const planCode = searchParams.get('planCode');
  const effectiveDateStart = searchParams.get('effectiveDateStart');
  const effectiveDateEnd = searchParams.get('effectiveDateEnd');
  
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCurrentUser = async () => {
      try {
        const user = await getCurrentUser();
        setCurrentUser(user);
      } catch (error) {
        console.error('Failed to fetch current user:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCurrentUser();
  }, []);

  // Determine if user is a Broker
  const isBroker = currentUser?.role?.name === 'Broker';

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4" gutterBottom>Eligibility Data</Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/eligibility/add')}
        >
          Add Eligibility Record
        </Button>
      </Box>
      
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
          <CircularProgress />
        </Box>
      ) : (
        <EligibilityTable 
          initialFilter={{
            activeStatus: activeStatus || undefined,
            groupId: groupId || undefined,
            planCode: planCode || undefined,
            effectiveDateStart: effectiveDateStart || undefined,
            effectiveDateEnd: effectiveDateEnd || undefined,
            // Add organizationId filter for Broker users
            ...(isBroker && currentUser?.organizationId ? { organizationId: currentUser.organizationId } : {})
          }}
        />
      )}
    </Box>
  );
};

export default EligibilityList;
